export const sidebarToggleEventId = 'ovpn:on-sidebar-toggle';
export const mobileSidebarToggleEventId = 'ovpn:on-mobile-sidebar-toggle';